import { useState } from "react";
import { KeyRound, X } from "lucide-react";
import { api, saveToken } from "../services/api";
import type { SessionInfo } from "../types";

export function ActivationModal({ open, onClose, onActivated }: { open: boolean; onClose: () => void; onActivated: (session: SessionInfo) => void }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (!open) return null;

  async function submit() {
    setLoading(true);
    setError("");
    try {
      const result = await api.activate(code);
      saveToken(result.token);
      onActivated(result);
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : "激活失败");
    } finally {
      setLoading(false);
    }
  }

  return <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
    <section className="modal" role="dialog" aria-modal="true" aria-labelledby="activation-title" onMouseDown={(event) => event.stopPropagation()}>
      <button className="icon-button close" onClick={onClose} aria-label="关闭"><X size={20} /></button>
      <div className="modal-icon"><KeyRound /></div>
      <p className="eyebrow">解锁个性化建议</p>
      <h2 id="activation-title">输入你的激活码</h2>
      <p className="muted">完整职场解读、每份行动方案或职场泄压仪式各消耗 1 次。抽牌与基础牌义免费。</p>
      <label className="field">
        <span>激活码</span>
        <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="请输入激活码" autoFocus onKeyDown={(e) => e.key === "Enter" && void submit()} />
      </label>
      {error && <p className="error" role="alert">{error}</p>}
      <button className="primary full" disabled={loading || code.trim().length < 6} onClick={() => void submit()}>{loading ? "正在验证…" : "立即激活"}</button>
      <p className="fineprint">激活码仅用于核验使用次数，不读取通讯录或设备标识。</p>
    </section>
  </div>;
}
